import { Card, Col, Row } from "react-bootstrap";

function PrivacyPolicy() {
    return (
        <Card>
            <Card.Body>
                <Row className=" w-100 ">
                    <Col xl={2} xs={3} className="p-1 d-sm-none d-md-block text-center">
                        <img
                            className="h-75 w-75 mt-2"
                            src="img/logo.png"
                        />
                    </Col>
                    <Col xl={3}></Col>
                    <Col className="mt-3"><strong>Privacy Policy</strong></Col>
                </Row>
                <Row className="mt-2">
                    <Col>
                        <div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
                            <p><strong>Effective Date:</strong> 15-02-2025</p>

                            <strong>1. Introduction</strong>
                            <p> &nbsp;&nbsp;
                                Welcome to Money Plant. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our market learning application.
                            </p>

                            <strong>2. Information We Collect</strong> <br />
                            &nbsp;&nbsp; We may collect and process the following types of information:
                            <ul>
                                <li><strong>Personal Information:</strong> Name, and other identifying details you provide.</li>
                                <li><strong>Account Information:</strong> Username, and password.</li>
                                <li><strong>Transaction Data:</strong> Details about trades, and transactions (No real money transactions).</li>
                                <li><strong>Device & Usage Information:</strong> IP address, browser type, device information, and usage patterns.</li>
                                <li><strong>Location Data:</strong> If enabled, we may collect your geolocation data to provide location-based services.</li>
                            </ul>

                            <strong>3. How We Use Your Information</strong> <br />
                            &nbsp;&nbsp; We use the collected data for:
                            <ul>
                                <li>Providing and maintaining the App’s functionality.</li>
                                <li>Improving user experience and developing new features.</li>
                                <li>Communicating updates, promotions, and security alerts.</li>
                            </ul>

                            <strong>4. Sharing Your Information</strong> <br />
                            &nbsp;&nbsp;
                            We do not sell or rent your personal data. However, we may share information in the following cases:
                            <ul>
                                <li>In the case of a merger, acquisition, or sale of assets.</li>
                            </ul>

                            <strong>5. Data Security</strong>
                            <p> &nbsp;&nbsp;
                                We implement industry-standard security measures to protect your information. However, no electronic transmission or storage method is 100% secure. Please use strong passwords and safeguard your account credentials.
                            </p>

                            <strong>6. Your Rights & Choices</strong><br />
                            &nbsp;&nbsp;
                            Depending on your location, you may have rights such as:
                            <ul>
                                <li>Restricting or objecting to data processing.</li>
                            </ul>

                            <strong>7. Cookies & Tracking Technologies</strong>
                            <p> &nbsp;&nbsp;
                                We may use cookies and similar technologies to enhance your experience. You can manage cookie preferences in your browser settings.
                            </p>

                            <strong>8. Third-Party Links</strong>
                            <p> &nbsp;&nbsp; The App does not contain any third-party links.</p>

                            <strong>9. Changes to This Policy</strong>
                            <p> &nbsp;&nbsp;
                                We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
                            </p>
                        </div>
                    </Col></Row>
            </Card.Body>
        </Card>
    );
}
export default PrivacyPolicy;